import React from 'react';
import { Navigate, Route, Routes, useParams } from 'react-router-dom';
import { trpc } from '@/utils/trpc-client';
import { CampaignContextProvider } from '@/features/campaigns/campaign-context';
import { ProposalRoutes } from '@/features/proposals/proposal-routes';
import { ExecutionRoutes } from '@/features/executions/execution-routes';
import { CampaignActivityPage } from '@/features/campaigns/CampaignActivityPage';

export function CampaignPage() {
  const { zohoCampaignId } = useParams<{ zohoCampaignId: string }>();
  const { data, isLoading, error } = trpc.campaignV2.useQuery({
    zoho_campaign_id: zohoCampaignId!
  });

  if (isLoading || !data) {
    return <div>Loading...</div>;
  }

  if (error) {
    return <div>Error loading campaign.</div>;
  }

  const defaultPath = data.has_execution ? 'execution' : 'proposal';

  return (
    <CampaignContextProvider campaign={data}>
      <Routes>
        <Route path="proposal/*" element={<ProposalRoutes />} />
        <Route path="execution/*" element={<ExecutionRoutes />} />
        <Route path="activity/*" element={<CampaignActivityPage />} />
        <Route index element={<Navigate to={defaultPath} replace />} />
      </Routes>
    </CampaignContextProvider>
  );
}
